import { render, staticRenderFns } from "./PasswordResetEmailSentModal.vue?vue&type=template&id=0f1fdede&scoped=true&"
import script from "./PasswordResetEmailSentModal.vue?vue&type=script&lang=js&"
export * from "./PasswordResetEmailSentModal.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetEmailSentModal.vue?vue&type=style&index=0&id=0f1fdede&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1fdede",
  null
  
)

export default component.exports